<div class="page-container">

  <!-- Header -->
  <div class="page-header">
    <div class="page-title-section">
      <mat-icon class="page-icon">mail</mat-icon>
      <div>
        <div class="page-title">Automatic notifications</div>
        <div class="page-subtitle">Edit the emails the system sends</div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="mat-elevation-z2 table-card">
    <table mat-table [dataSource]="dataSource" matSort aria-label="Automatic notifications list">

      <!-- Name -->
      <ng-container matColumnDef="displayName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Notification</th>
        <td mat-cell *matCellDef="let row">
          <div class="name">{{ row.displayName }}</div>
          <div class="desc" *ngIf="row.description">{{ row.description }}</div>
        </td>
      </ng-container>

      <!-- Subject -->
      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Subject</th>
        <td mat-cell *matCellDef="let row">{{ row.subject }}</td>
      </ng-container>

      <!-- Channel -->
      <ng-container matColumnDef="channel">
        <th mat-header-cell *matHeaderCellDef>Format</th>
        <td mat-cell *matCellDef="let row">{{ row.isHtml ? 'HTML' : 'Text' }}</td>
      </ng-container>

      <!-- Tokens -->
      <ng-container matColumnDef="tokens">
        <th mat-header-cell *matHeaderCellDef>Variables</th>
        <td mat-cell *matCellDef="let row">{{ row.tokens.length }}</td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions-header">Action</th>
        <td mat-cell *matCellDef="let row" class="actions-cell">
          <button
            mat-icon-button
            class="action-btn edit-btn"
            (click)="onEdit(row); $event.stopPropagation()"
            [attr.aria-label]="'Edit ' + row.displayName"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row" (click)="onEdit(row)"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
          No notification templates found.
        </td>
      </tr>
    </table>
  </div>

  <!-- Footer -->
  <div class="footer-actions">
    <button mat-stroked-button class="go-back-btn" (click)="goBack()" aria-label="Go back">
      GO BACK
    </button>
  </div>

</div>
